﻿require('./site_ynet_articleVerticalSocialShare.less');
import * as ResizeObserver from "resize-observer-polyfill";
import { SiteArticleSocialShareNew1280 } from "../articleSocialShare1280Component/articleSocialShareNew1280";
import { SiteArticleActionBar1280 } from "../articleSocialShare1280Component/SiteArticleActionBar1280";

const MAGAZINE_LAYOUT_SELECTOR = ".magazine2025, .magazine_art";
const HORIZONTAL_ACTION_BAR_SELECTOR = ".ArticleHorizontalActionBar";

interface Props {
    categorySubChannel: string
    author: string
    articleId: string
    isBottomButtons?: boolean
    showComments: boolean
    isSpotim: boolean
    lang?: string
    actionBarMode?: boolean
    title?: string
    readAloudUrl?: string | null
    readAloudDuration?: number | null
    mediaImageUrl?: string
    domain?: string
    imagesDomain?: string
}

interface state {
    wrapperStyle: React.CSSProperties
}

export class SiteArticleVerticalSocialShare extends React.Component<Props, state> {
    static siteScriptName = "SiteVerticalArticleSocialShare"

    constructor(props) {
        super();
        //@ts-ignore
        if (ResizeObserver) {
            this.resizeObserver = new ResizeObserver(records => records.forEach(r => {
                this.onContentHeightChanged(r.contentRect.height)
            }))
        }


        this.state = {
            wrapperStyle: {
                height: "auto",
                visibility: props.showAlways ? "visible" : "hidden",
                opacity: 0,
                transition: "visibility 0s ease-out 100ms, opacity 400ms",
            },
        }
    }
    //@ts-ignore
    private resizeObserver: ResizeObserver;
    private intersectionObserver: IntersectionObserver;
    private wrapperRef: HTMLDivElement | null = null;

    componentDidMount() {
        const isShowAlways = !document.getElementById("YnetHeader") || (!!document.getElementById("YnetHeader") && !!document.getElementById("MagazineArticleTopMedia"));
        const horizontalBar = this.getMagazineHorizontalBar();
        if (IntersectionObserver) {
            this.intersectionObserver = horizontalBar
                ? this.createHorizontalBarObserver()
                : new IntersectionObserver(entries => entries.forEach(entry => this.setVisibility(entry.isIntersecting, isShowAlways)));
        }
        const itemToMatchHeightWith = document.getElementsByClassName("article-body")[0] || document.getElementsByClassName("article-body-radionas")[0];
        const widgetElement = document.getElementsByClassName("article-vertical-social-share")[0];
        const scrollTopOfItemToMatchHeightWith = itemToMatchHeightWith.getBoundingClientRect().top - widgetElement.getBoundingClientRect().top + window.pageYOffset;
        this.resizeObserver.observe(itemToMatchHeightWith);
        const headerElem = document.getElementById("YnetHeader") || document.getElementById("RadionasHeader") || document.getElementById("MagazineHeader");
        const observeTarget = horizontalBar || (isShowAlways ? headerElem : document.getElementById("ArticleHeaderComponent"));
        this.intersectionObserver.observe(observeTarget);
        this.setState({
            wrapperStyle: {
                ...this.state.wrapperStyle,
                top: isShowAlways ? "0px" : scrollTopOfItemToMatchHeightWith + "px",
            }
        })
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = null;
        }
    }

 private onContentHeightChanged(height: number) {
        const element = document.getElementsByClassName("articleContainer magazine2025")[0]
            || document.getElementsByClassName("articleContainer magazine_art")[0];
        const commentElement = document.getElementsByClassName("Talkbacks-widget")[0]
            || document.getElementsByClassName("Talkbacks-widget-grid1280-2")[0];
        const tagsElement = document.getElementsByClassName("article-tags-1280-2")[0];
        const articleBodyElement = document.getElementsByClassName("article-body")[0];
        // HTMLCollection is always truthy; guard [0] so missing tags don't throw before setState
        const calcheight = element && (
            (tagsElement ? tagsElement.getBoundingClientRect().height : 0)
            + (articleBodyElement ? articleBodyElement.getBoundingClientRect().height : 0)
            + (commentElement ? commentElement.getBoundingClientRect().height : 0)
        );
        const radionasContainer = document.getElementsByClassName("articleContainer radionas")[0];
        const radionasHeight = radionasContainer && radionasContainer.getBoundingClientRect().height;
        const articleContainerHeight = calcheight ? calcheight : radionasHeight ? radionasHeight : height;
        const isShowAlways = !document.getElementById("YnetHeader");
        this.setState({
            wrapperStyle: {
                ...this.state.wrapperStyle,
                height: isShowAlways ? `${articleContainerHeight}px` : `${height}px`
            },
        })
    }

    private setVisibility = (isIntersecting: boolean, isShowAlways:boolean) => {    
        this.setState({
            wrapperStyle: {
                ...this.state.wrapperStyle,
                visibility: isIntersecting &&  !isShowAlways ? "hidden" : "visible",
                opacity: isIntersecting && !isShowAlways ? 0 : 1,
            }
        })
    }

    private getMagazineHorizontalBar(): Element | null {
        return document.querySelector(MAGAZINE_LAYOUT_SELECTOR) ? document.querySelector(HORIZONTAL_ACTION_BAR_SELECTOR) : null;
    }

    private getVerticalStickyTop(): number {
        const stickyBar = this.wrapperRef && this.wrapperRef.firstElementChild;
        return stickyBar ? parseInt(window.getComputedStyle(stickyBar).top, 10) || 0 : 0;
    }

    private createHorizontalBarObserver(): IntersectionObserver {
        const stickyTop = this.getVerticalStickyTop();
        return new IntersectionObserver(entries => entries.forEach(entry => {
            const isPastStickyLine = !entry.isIntersecting && entry.boundingClientRect.bottom <= stickyTop;
            this.setHorizontalGateVisibility(isPastStickyLine);
        }), { rootMargin: `-${stickyTop}px 0px 0px 0px` });
    }

    private setHorizontalGateVisibility = (isVisible: boolean) => {
        this.setState(prev => ({
            wrapperStyle: {
                ...prev.wrapperStyle,
                visibility: isVisible ? "visible" : "hidden",
                opacity: isVisible ? 1 : 0,
            }
        }))
    }

    render() {
        const { wrapperStyle } = this.state;
        const { actionBarMode, isSpotim: _isSpotim, ...actionBarProps } = this.props;
        return (
            <div className={"SiteVerticalArticleSocialShare_Wrapper" + (actionBarMode ? " SiteVerticalArticleSocialShare_Wrapper--action-bar" : "")} id="SiteVerticalArticleSocialShare_Wrapper" style={wrapperStyle} ref={(el) => { this.wrapperRef = el }}>
                {actionBarMode
                    ? <SiteArticleActionBar1280
                        {...actionBarProps}
                        verticalSidebar
                        isReadAloudPlayerHost={false}
                    />
                    : <SiteArticleSocialShareNew1280 {...this.props} verticalSidebar />
                }
            </div>
        )
    }
}
